import { FaCheckCircle, FaArrowRight } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import Counter from "../components/common/Counter";
import { TeamCard } from "../components/common/Cards";
import CtaBanner from "../components/common/CtaBanner";
import { stats, features, team } from "../data/content";
import { ABOUT_APP } from "../data/images";
import { BOOKING_URL } from "../data/config";

export default function About() {
  return (
    <>
      <PageHeader title="About Us" crumbs={[{ label: "About Us" }]} />

      <section className="section">
        <div className="container two-col">
          <div className="about-single">
            <img src={ABOUT_APP} alt="Taxi24hrs 24 hours customer support" />
          </div>
          <div>
            <SectionTitle
              align="left"
              subtitle="Who We Are"
              title="Your Trusted Partner in <span>Safe City Travel</span>"
              text="Taxi24hrs was founded with a simple mission: to make city travel safe, affordable and effortless for everyone. Over a decade later, we're proud to be the most trusted taxi service in the region."
            />
            <p className="sec-text" style={{ marginBottom: 22 }}>
              We combine professional, well-trained drivers with a modern,
              well-maintained fleet and smart technology to deliver a seamless
              ride experience every single time.
            </p>
            <ul className="about-page-list">
              <li><FaCheckCircle /> Professional and experienced drivers</li>
              <li><FaCheckCircle /> Affordable and transparent pricing</li>
              <li><FaCheckCircle /> Comfortable and clean vehicles</li>
              <li><FaCheckCircle /> Fast and reliable 24/7 transportation</li>
            </ul>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary mt-2">
              Book online Now <FaArrowRight />
            </a>
          </div>
        </div>
      </section>

      <section className="section-sm stats-section">
        <div className="container stats-row">
          {stats.map((s, i) => (
            <div className="stat-item" key={i}>
              <div className="num"><Counter end={s.value} suffix={s.suffix} /></div>
              <div className="lbl">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-dark2">
        <div className="container">
          <SectionTitle subtitle="Our Values" title="What Makes Us <span>Different</span>" />
          <div className="grid grid-3 values-grid">
            {features.map((f, i) => (
              <div className="feature-box card" key={i}>
                <div className="fi">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionTitle subtitle="Our Team" title="Meet the People <span>Behind Taxi24hrs</span>" />
          <div className="grid grid-4">
            {team.map((m) => <TeamCard key={m.id} member={m} />)}
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
